import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CtasIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Ctas",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m29.91 19.26-6.34-7.04a.515.515 0 0 0-.88.34v9.48c.04.24.25.42.5.42.04 0 .09 0 .13-.02s2.07-.79 2.07-.79l1.46 3.83c.08.19.26.32.48.32.06 0 .13-.01.18-.03s1.27-.48 1.27-.48c.19-.08.32-.26.32-.48 0-.06-.01-.13-.03-.18l-1.46-3.82 2.07-.79c.18-.08.31-.26.31-.47 0-.11-.03-.21-.09-.29Zm-8.97-6.72a2.26 2.26 0 0 1 2.26-2.21c.67 0 1.26.29 1.68.74s2.82 3.04 2.82 3.04v-4.7c0-1.77-1.44-3.21-3.21-3.21H5.21C3.44 6.2 2 7.64 2 9.41v5.27c0 1.77 1.44 3.2 3.21 3.2h15.71v-5.35Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25 11h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1 .45 1 1s-.45 1-1 1H7c-1.65 0-3-1.35-3-3V5c0-1.65 1.35-3 3-3h18c1.65 0 3 1.35 3 3v3c0 1.65-1.35 3-3 3"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15 21c-.55 0-1-.45-1-1V10c0-1.65 1.35-3 3-3s3 1.35 3 3v7c0 .55-.45 1-1 1s-1-.45-1-1v-7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23 18c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55-.45 1-1 1s-1-.45-1-1v-2c0-1.65 1.35-3 3-3s3 1.35 3 3v2c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27 20c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55-.45 1-1 1s-1-.45-1-1v-1c0-1.65 1.35-3 3-3s3 1.35 3 3v2c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23 18c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23 26h-8c-2.76 0-5-2.24-5-5v-3c0-1.65 1.35-3 3-3h2c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1v-2h-1c-.55 0-1 .45-1 1v3c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 2.76-2.24 5-5 5M26 30H12c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1"
      })]
    })
  }));
};